exports = module.exports = require("./../../../node_modules/custom-react-scripts/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._75ZLXP66twNv63dCw5mta{padding-bottom:1em}._2pf41009DwgswTrIULV66h{margin-bottom:1em}._1eSIcQkY-ld39u-L3jh-iC{margin-right:6px;vertical-align:text-bottom}._3K3qF36XEfiTTM2xqjkZ79{margin:0 5px}", ""]);

// exports
exports.locals = {
	"form": "_75ZLXP66twNv63dCw5mta",
	"input": "_2pf41009DwgswTrIULV66h",
	"searchIcon": "_1eSIcQkY-ld39u-L3jh-iC",
	"submitButton": "_3K3qF36XEfiTTM2xqjkZ79"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/custom-react-scripts/~/css-loader?modules&-autoprefixer&importLoaders=1!./~/custom-react-scripts/~/postcss-loader!./src/components/manual-entry/style.css
 ** module id = 349
 ** module chunks = 0
 **/